.dropdown {
  position: absolute;
  z-index: var(--cxy-z-index-control-highest);
  width: 100%;
  background-color: white;
  border: 1px solid #d4d4d8;
  border-radius: 0.375rem;
  margin-top: 0.25rem;
  max-height: 15rem;
  overflow-y: auto;
}

.dropdown.dark {
  border-color: #262626;
}

.dropdownItem {
  padding: 0.5rem 1rem;
  cursor: pointer;
  color: #00182e;
}

.dropdownItem:hover {
  background-color: #e5e7eb;
}

.dropdownItemActive {
  background-color: #e5e7eb;
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .dropdownItem:hover,
  .dropdownItemActive {
    background-color: var(--cxy-color-pink-400);
  }
}
